import { render, staticRenderFns } from "./CoverPeriod.vue?vue&type=template&id=603cdd04&"
import script from "./CoverPeriod.vue?vue&type=script&lang=js&"
export * from "./CoverPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports